class DotoSiteHeader {
  constructor(shell) {
    this.shell = shell;
    this.header = shell.querySelector('[data-doto-site-header]');
    this.isHomeOverlay = shell.dataset.homeOverlay === 'true';
    this.solidThreshold = Number.parseInt(shell.dataset.solidThreshold || '10', 10);
    this.anchorY = 0;
    this.ticking = false;

    this.drawer = shell.querySelector('[data-doto-drawer]');
    this.openButton = shell.querySelector('[data-doto-drawer-open]');
    this.closeButton = shell.querySelector('[data-doto-drawer-close]');
    this.desktopCategoryGroups = Array.from(shell.querySelectorAll('[data-doto-category-group]'));
    this.mobileCategoryGroups = Array.from(shell.querySelectorAll('[data-doto-mobile-category-group]'));
    this.desktopBreakpoint = window.matchMedia('(min-width: 992px)');

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.bind();
    this.measure();
    this.update();
    this.configureAppLink();
    this.configureCategoryGroups();
  }

  bind() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    document.addEventListener('click', this.onDocumentClick);
    this.desktopBreakpoint.addEventListener?.('change', this.onBreakpointChange);

    this.openButton?.addEventListener('click', () => {
      if (!this.drawer?.showModal) return;
      this.closeMobileCategoryGroups();
      this.drawer.showModal();
      document.documentElement.classList.add('doto-nav-lock');
    });

    this.closeButton?.addEventListener('click', () => this.closeDrawer());

    this.drawer?.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.closeDrawer();
    });

    this.drawer?.addEventListener('close', () => {
      document.documentElement.classList.remove('doto-nav-lock');
    });
  }

  configureCategoryGroups() {
    if (this.desktopBreakpoint.matches) {
      this.desktopCategoryGroups.forEach((group) => group.setAttribute('open', ''));
    } else {
      this.desktopCategoryGroups.forEach((group) => group.removeAttribute('open'));
      this.closeMobileCategoryGroups();
    }
  }

  closeMobileCategoryGroups() {
    this.mobileCategoryGroups.forEach((group) => group.removeAttribute('open'));
  }

  onBreakpointChange() {
    this.configureCategoryGroups();
  }

  closeDrawer() {
    if (this.drawer?.open) this.drawer.close();
    document.documentElement.classList.remove('doto-nav-lock');
  }

  configureAppLink() {
    const appLink = this.shell.querySelector('[data-doto-app-link]');
    if (!appLink) return;

    const iosUrl = appLink.dataset.iosUrl;
    const androidUrl = appLink.dataset.androidUrl;
    const ua = navigator.userAgent || '';

    if (/Android/i.test(ua) && androidUrl) {
      appLink.href = androidUrl;
    } else if (/iPad|iPhone|iPod/i.test(ua) && iosUrl) {
      appLink.href = iosUrl;
    } else if (!appLink.getAttribute('href') || appLink.getAttribute('href') === '#') {
      appLink.href = androidUrl || iosUrl || '#';
    }
  }

  measure() {
    if (!this.header) return;
    const height = Math.ceil(this.header.getBoundingClientRect().height);
    this.shell.style.setProperty('--doto-header-height', `${height}px`);
    document.documentElement.style.setProperty('--doto-navbar-height', `${height}px`);

    const wasFixed = this.shell.classList.contains('is-fixed');
    if (wasFixed) this.shell.classList.remove('is-fixed');
    this.anchorY = this.shell.getBoundingClientRect().top + window.scrollY;
    if (wasFixed) this.shell.classList.add('is-fixed');
  }

  onResize() {
    window.requestAnimationFrame(() => {
      this.measure();
      this.update();
    });
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const scrollY = window.scrollY;
    const solid = !this.isHomeOverlay || scrollY > this.solidThreshold;
    const fixed = scrollY >= this.anchorY;

    this.shell.classList.toggle('is-solid', solid);
    this.shell.classList.toggle('is-fixed', fixed);
  }

  onDocumentClick(event) {
    this.shell.querySelectorAll('[data-doto-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('click', this.onDocumentClick);
    this.desktopBreakpoint.removeEventListener?.('change', this.onBreakpointChange);
    document.documentElement.classList.remove('doto-nav-lock');
  }
}

const dotoHeaderInstances = new Map();

function initDotoHeader(shell) {
  if (!shell || dotoHeaderInstances.has(shell)) return;
  dotoHeaderInstances.set(shell, new DotoSiteHeader(shell));
}

function destroyDotoHeader(shell) {
  dotoHeaderInstances.get(shell)?.destroy();
  dotoHeaderInstances.delete(shell);
}

document.querySelectorAll('[data-doto-site-header-shell]').forEach(initDotoHeader);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('[data-doto-site-header-shell]').forEach(initDotoHeader);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll?.('[data-doto-site-header-shell]').forEach(destroyDotoHeader);
});

document.addEventListener('shopify:section:select', (event) => {
  event.target.querySelectorAll?.('[data-doto-site-header-shell]').forEach((shell) => {
    initDotoHeader(shell);
    dotoHeaderInstances.get(shell)?.onResize();
  });
});
